import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROUTE } from "../routes";
import { env } from "../utils/env";

const fetchExtraAction = (authHeader: string, individualId: number) => () =>
  axios.get(
    `${env.verifyServiceUrl}individual/individual_v2/${individualId}/get_extra_action/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );
export const useGetExtraAction = (individualId: number) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(
    ["extra_action", individualId],
    fetchExtraAction(authHeader, individualId),
    {
      enabled: !!individualId,
      retry: false,
      onError: (err: any) => {
        //   if (err.request.status === 500 || err.request.status === 503) {
        //     navigate(ROUTE.SERVER_ERROR);
        //   }
        if (err.request.status === 401) {
          navigate(ROUTE.LOGOUT);
        }
      },
    }
  );
};
